import { connect } from 'react-redux';
import { getAverageProductPrice, getProductSoldCount } from '../selectors';
import ProductsSold from '../components/ProductsSold';

const ProductsSoldContainer = connect(state => ({
  averageProductSale: getAverageProductPrice(state),
  productsSold: getProductSoldCount(state),
}))(ProductsSold);

export default ProductsSoldContainer;
